{
  "version": 1,
  "asset_id": "d0fee799-8c6b-4044-92f6-934f5ecaf162",
  "project_id": "4e628cc3-9baa-4a87-b23b-02ac04e85c33",
  "url": "/__l5e/assets-v1/d0fee799-8c6b-4044-92f6-934f5ecaf162/resultado_3.png",
  "r2_key": "a/v1/4e628cc3-9baa-4a87-b23b-02ac04e85c33/d0fee799-8c6b-4044-92f6-934f5ecaf162/resultado_3.png",
  "original_filename": "resultado_3.png",
  "size": 975944,
  "content_type": "image/png",
  "created_at": "2026-07-07T11:53:10Z"
}
